import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";

import Header from "./components/Header";
import Hero from "./components/Hero";
import MarketOpportunity from "./components/MarketOpportunity";
import VirtualBrandsBento from "./components/VirtualBrandsBento";
import HowItWorks from "./components/HowItWorks";
import WhyUs from "./components/WhyUs";
import Requirements from "./components/Requirements";
import JourneyForm from "./components/JourneyForm";
import FAQSection from "./components/FAQSection";
import Footer from "./components/Footer";

const HomePage = () => {
  return (
    <div className="App">
      <Header />
      <main>
        <Hero />
        <MarketOpportunity />
        <VirtualBrandsBento />
        <HowItWorks />
        <WhyUs />
        <Requirements />
        <JourneyForm />
        <FAQSection />
      </main>
      <Footer />
      <Toaster position="top-right" />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
